<div class="info-card p-3" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon>person</mat-icon>
      <span class="subtitle-default">Tenant Information</span>
    </div>
  </div>


  <div fxLayout="column" fxLayoutGap="16px">
    @if (allowedRetailerTenantTypes().length > 1) {
      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Occupancy</span>
        <div class="custom-select-field full-width">
          <mat-button-toggle-group [(ngModel)]="selectedRetailerTenantType"
                                   hideSingleSelectionIndicator
                                   class="custom-date-button-toggle">
            @for (tenantType of allowedRetailerTenantTypes(); track tenantType) {
            <mat-button-toggle [value]="tenantType">{{ tenantTypeDisplayLabel(tenantType)() }}</mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>
      </div>
    }

    <form [formGroup]="retailerForm" class="tenant-form">
      <div fxLayout="column" fxLayoutGap="16px">
        <span class="body-3-default">Choose a retailer</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <app-retailer-lookup
            formControlName="retailerCompanyName"
            [disabled]="!!(loader.loading$ | async)"
            [offeringUuid]="offering.offeringUuid"
            [options]="_retailerLookupOptions()"
            [required]="true"
            [value]="bookingConfig.retailerId"
            (retailerSelected)="selectRetailer($event)">
          </app-retailer-lookup>
          <mat-error class="link-error">Please select a retailer</mat-error>
        </mat-form-field>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-1-default">Email Address</span>
        <mat-form-field class="custom-text-autofill" style="max-width: 100%" appearance="outline">
          <input matInput type="email" formControlName="userEmail" placeholder="owner@business.com">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div class="full-width" fxLayout="column" fxLayoutGap="7px" fxFlex="50">
          <span class="body-1-default">First Name</span>
          <mat-form-field class="custom-text-autofill" style="max-width: 100%" appearance="outline">
            <input matInput formControlName="firstName" placeholder="John">
          </mat-form-field>
        </div>
        <div class="full-width" fxLayout="column" fxLayoutGap="7px" fxFlex="50">
          <span class="body-1-default">Last Name</span>
          <mat-form-field class="custom-text-autofill" style="max-width: 100%" appearance="outline">
            <input matInput formControlName="lastName" placeholder="Doe">
          </mat-form-field>
        </div>
      </div>
    </form>

    <div class="navigation-buttons">
      <button class="button-secondary" mat-flat-button (click)="prevStep()">Back</button>
      <button class="button-primary" mat-flat-button (click)="submitForm()" [disabled]="!canSubmitForm">
        <div class="button-text">Review & Save</div>
      </button>
    </div>

  </div>
</div>
